const moduleName = 'optional';

export function optional() {

    Array.from(document.querySelectorAll('.js-optional')).forEach((self) => {
        if (self.dataset[moduleName + 'Init'] === 'true') return;
        self.dataset[moduleName + 'Init'] = true;

        const holder = self;
        const list = holder.querySelector('.js-optional-list');
        const listInner = holder.querySelector('.js-optional-list-inner');
        const moreButton = holder.querySelector('.js-optional-more-button');

        if (!moreButton) return;

        moreButton.addEventListener('click', () => {
            list.style.height = list.offsetHeight + 'px';
            holder.classList.add('_open');

            setTimeout(() => {
                list.style.height = listInner.offsetHeight + 'px';
                triggerEvent(window, 'scroll');

                setTimeout(() => {
                    list.style.height = '';
                }, 500);
            }, 10);
        });
    });



    function triggerEvent(element, eventName) {
        let customEvent;

        if (typeof(Event) === 'function') {
            customEvent = new Event(eventName);
        } else {
            customEvent = document.createEvent('Event');
            customEvent.initEvent(eventName, true, true);
        }

        element.dispatchEvent(customEvent);
    }

}